import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { WithContext as ReactTags } from 'react-tag-input';
import { Flex } from 'reflexbox';
import { Button } from '~/components';
import { SearchIcon } from '~/icons';
import { CleanBtn, Label } from '~/pages/Analysis/Utilities/UtilityFilter/styles';
import {
  IconWrapperSearch, SearchTagInput, StyledContainerArea, StyledSearchInput,
} from './styles';
import { PageState } from './types';

interface FiltersProps {
  loading: boolean;
  state: PageState;
  clearFilters: () => void;
  onClickFilter: () => void;
  onSearchDelete: (i: number) => void,
  onSearchAddition: (tag: { text: string }) => void,
  render: () => void;
}

export function Filters({
  loading,
  state,
  clearFilters,
  onClickFilter,
  onSearchAddition,
  onSearchDelete,
  render,
}: Readonly<FiltersProps>): ReactElement {
  const { t } = useTranslation();

  const KeyCodes = {
    comma: 188,
    slash: 191,
    enter: [10, 13],
  };
  const delimiters = [...KeyCodes.enter, KeyCodes.comma, KeyCodes.slash];

  return (
    <div style={{
      width: '100%',
    }}
    >
      <Flex alignItems="center" flexWrap="wrap" style={{ gap: '5px' }} flexDirection="row">
        <StyledSearchInput>
          <StyledContainerArea>
            <Label>{t('cliente')}</Label>
            <SelectSearch
              options={state.clients}
              value={state.selectedClients}
              search
              printOptions="on-focus"
              filterOptions={fuzzySearch}
              closeOnSelect
              onChange={(value) => {
                console.log('value', value);
                state.selectedClients = value as unknown as string[];
                render();
              }}
              placeholder={t('selecioneCliente')}
              multiple
            />
          </StyledContainerArea>
        </StyledSearchInput>
        <StyledSearchInput>
          <StyledContainerArea>
            <Label>{t('unidade')}</Label>
            <SelectSearch
              options={state.units}
              value={state.selectedUnits}
              search
              printOptions="on-focus"
              filterOptions={fuzzySearch}
              closeOnSelect
              onChange={(value) => {
                console.log('value', value);
                state.selectedUnits = value as unknown as string[];
                render();
              }}
              placeholder={t('selecioneUnidade')}
              multiple
            />
          </StyledContainerArea>
        </StyledSearchInput>
        <StyledSearchInput>
          <StyledContainerArea>
            <Label>{t('estado')}</Label>
            <SelectSearch
              options={state.states}
              value={state.selectedStates}
              search
              printOptions="on-focus"
              filterOptions={fuzzySearch}
              closeOnSelect
              onChange={(value) => {
                console.log('value', value);
                state.selectedStates = value as unknown as string[];
                render();
              }}
              placeholder={t('selecioneOsEstados')}
              multiple
            />
          </StyledContainerArea>
        </StyledSearchInput>
        <StyledSearchInput>
          <StyledContainerArea>
            <Label>{t('cidade')}</Label>
            <SelectSearch
              options={state.cities}
              value={state.selectedCities}
              search
              printOptions="on-focus"
              filterOptions={fuzzySearch}
              closeOnSelect
              onChange={(value) => {
                console.log('value', value);
                state.selectedCities = value as unknown as string[];
                render();
              }}
              placeholder={t('selecioneAsCidades')}
              multiple
            />
          </StyledContainerArea>
        </StyledSearchInput>
        <StyledSearchInput>
          <StyledContainerArea>
            <Label>{t('conexao')}</Label>
            <SelectSearch
              options={state.connections}
              value={state.selectedConnections}
              search
              printOptions="on-focus"
              filterOptions={fuzzySearch}
              closeOnSelect
              onChange={(value) => {
                console.log('value', value);
                state.selectedConnections = value as unknown as string[];
              }}
              placeholder={t('selecioneAConexao')}
              multiple
            />
          </StyledContainerArea>
        </StyledSearchInput>
        <SearchTagInput>
          <div style={{ width: '100%' }}>
            <Label>{t('pesquisar')}</Label>
            <ReactTags
              tags={state.searchState}
              handleDelete={(tag) => {
                onSearchDelete(tag);
              }}
              handleAddition={(tag) => {
                onSearchAddition(tag);
              }}
              delimiters={delimiters}
              allowDragDrop={false}
              allowDeleteFromEmptyInput={false}
              inputFieldPosition="top"
              minQueryLength={2}
              placeholder=""

            />
          </div>
          <IconWrapperSearch>
            <SearchIcon />
          </IconWrapperSearch>
        </SearchTagInput>
        <Button
          style={{
            width: '110px',
            marginLeft: '20px',
            minWidth: '100px',
            display: 'flex',
            alignItems: 'center',
            height: '41px',
            textTransform: 'capitalize',
            justifyContent: 'center',
          }}
          type="button"
          variant={loading ? 'disabled' : 'primary'}
          onClick={onClickFilter}
        >
          {t('filtrar')}
        </Button>
      </Flex>
      <div>
        <CleanBtn onClick={clearFilters} style={{ marginLeft: 2 }}>
          {t('limparFiltros')}
        </CleanBtn>
      </div>
    </div>
  );
}
